<template>
    <div class="mt-8 w-full h-full bg-white">
      <Roles
        v-loading="loading"
        element-loading-text="Loading..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"/>
    </div>
  </template>

<script>
import Roles from '../components/roles/Roles.vue';

export default {
  name: 'RoleView',
  data() {
    return {
      loading: false,
    };
  },
  components: {
    Roles,
  },
  methods: {
    async fetchRoles() {
      try {
        this.$store.dispatch('SecurityModule/Role/fetchAllRoles');
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
    },
  },
  mounted() {
    this.loading = true;
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    this.fetchRoles();
    this.loading = false;
  },
};
</script>

<style scoped></style>
